import fitToScreen from '../helpers/fitToScreen';
import reveal from '../helpers/reveal';

interface IPrimaryHeroConfig {
  htmlElement: HTMLElement,
  img: IPrimaryHeroImg;
  selectors: IPrimaryHeroSelectors
}

interface IPrimaryHeroImg {
  htmlElement: HTMLElement
}

interface IPrimaryHeroSelectors {
  main: string,
  img: string
}

class PrimaryHero {
  
  private config: IPrimaryHeroConfig;
  
  constructor() {
    this.config = {
      htmlElement: null,
      img: {
        htmlElement: null
      },
      selectors: {
        main: '[data-primary-hero]',
        img: '[data-primary-hero-img]'
      }
    }
  }
  
  public init() {
    document.querySelectorAll(this.config.selectors.main).forEach((htmlElement: HTMLElement) => {
      this.load(htmlElement);
    });
  }

  public load(htmlElement: HTMLElement) {
    this.config.htmlElement = htmlElement;
    this.config.img.htmlElement = this.config.htmlElement.querySelector(this.config.selectors.img);
    if (this.config.img.htmlElement) fitToScreen.load(this.config.img.htmlElement);
    reveal.closestHideClassName(this.config.htmlElement);
  }
}

export default new PrimaryHero();